<!-- TEMPLATE -->
<template>
    <div class="dean-form-row">
        <div class="row">
            <div class="small-6 medium-6 large-6 hd-6 columns" v-if="!hideLabel">
                <p class="input-label">{{ label }} <span style="color:red">{{requiredField ? '*' : ''}}</span></p>
            </div>
            <div :class="{ 'small-6 medium-6 large-6 hd-6 columns': !hideLabel, 'small-12 medium-12 large-12 hd-12 columns': hideLabel}">
                <dean-input-field
                        :type="deanInputFieldType"
                        :value="value"
                        :id="id"
                        :validation="validation"
                        :tab-index="tabIndex"
                        :required-field="requiredField"
                        :disabled="disabled"
                        :warning="warning"
                        @input="valueChange"
                        @focus="focus($event)"
                        :step="step"
                        :max="max"
                        :min="min"
                        >
                    <slot>{{ label }}</slot>
                </dean-input-field>
            </div>
        </div>
    </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
    // VUE
    import Vue from 'vue';
    import { Component, Prop, Watch } from 'vue-property-decorator';

    // COMPONENTS
    import deanInputField from './deanInputField.vue';

    @Component({
        components: {
            deanInputField,
        },

        // FILTERS
        filters: {
            capitalize(value: any) {
                if (!value) {
                    return '';
                }
                const text = value.toString();
                return text.charAt(0).toUpperCase() + text.slice(1);
            },
            regularCaseString(value: any) {
                if (!value) {
                    return '';
                }

                const text = value.toString();
                return text.replace(/([A-Z])/g, ' $1');
            },
        },
    })

    export default class DeanFormRow extends Vue {

        // PROPS
        @Prop({default: ''}) protected value!: string;
        @Prop({default: true}) protected text!: boolean;
        @Prop({default: false}) protected disabled!: boolean;
        @Prop({default: false}) protected password!: boolean;
        @Prop({default: false}) protected number!: boolean;
        @Prop({default: false}) protected warning!: boolean;
        @Prop({default: false}) protected requiredField!: boolean;
        @Prop({default: ''}) protected type!: string;
        @Prop({default: ''}) protected label!: string;
        @Prop({default: ''}) protected validation!: string;
        @Prop({default: ''}) protected id!: string;
        @Prop() protected tabIndex!: number;
        @Prop({default: ''}) protected min!: string;
        @Prop({default: ''}) protected max!: string;
        @Prop({default: ''}) protected step!: string;
        @Prop({default: false}) protected hideLabel!: boolean;

        public focus(event: any) {
            if (event) {
                this.$emit('focus');
            }
        }

        public valueChange(value: any) {
            this.$emit('input', value);
        }

        // COMPUTED
        get deanInputFieldType() {
            let value = 'text';
            if (this.text) {
                value = `text`;
            }
            if (this.password) {
                value = `password`;
            }
            if (this.number) {
                value = `number`;
            }
            if (this.type) {
                value = `${this.type}`;
            }
            return value;
        }
    }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

    // IMPORT
    @import '~@deanone/dean-components/src/scss/vars';

    .input-label {
        padding-left: 20px;
    }

</style>
